
<app-type-caracteristiquesMAPA id="step3" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [caracteristiques]="initial.caracteristiques"></app-type-caracteristiquesMAPA>
